import type { ModalMapType } from "../../../../../common-deprecated/types/CommonTypes";
import { aemLexusCommonModalMap } from "../../../../../common-deprecated/components/modals/aem/lexus/modals";
import {
    type CompareV2ModalIdsType,
    MODAL_DELETE_CAR,
    MODAL_REPLACE_CAR,
    MODAL_SELECT_ENGINE,
} from "../../../../../shared-logic/features/compare/utils/modalConstants";
import LexusDeleteCarModal from "./DeleteCarModal";
import LexusReplaceCarModal from "./ReplaceCarModal";
import LexusSelectEngineModal from "./SelectEngineModal";

export const aemLexusCompareModalMap: ModalMapType<CompareV2ModalIdsType> = {
    ...aemLexusCommonModalMap,
    [MODAL_DELETE_CAR]: LexusDeleteCarModal,
    [MODAL_REPLACE_CAR]: LexusReplaceCarModal,
    [MODAL_SELECT_ENGINE]: LexusSelectEngineModal,
};
